<div class="container-fluid py-2">

@if (currentTier() === 'primaire') {

  <!-- ═══════════════════════════════════════════════════════════════
       DASHBOARD · PRIMAIRE
       ═══════════════════════════════════════════════════════════════ -->
  <div class="prim">

    <app-prim-hero [firstName]="primFirstName"></app-prim-hero>

    <!-- Erreur de chargement de la progression : jamais de données de substitution -->
    @if (progressionErrored()) {
      <app-error-state titleKey="DASHBOARD.ERROR_TITLE"
                       messageKey="DASHBOARD.ERROR_DESC"
                       (retry)="reloadProgression()"></app-error-state>
    }

    <div class="prim-grid">
      <app-prim-quest-card class="prim-grid__quest"
                           [nextSession]="nextSession()"></app-prim-quest-card>

      <app-prim-xp-card class="prim-grid__xp" [xp]="primXp"></app-prim-xp-card>

      @if (subjectsErrored()) {
        <app-error-state class="prim-grid__subjects"
                         titleKey="DASHBOARD.ERROR_TITLE"
                         messageKey="DASHBOARD.ERROR_DESC"
                         (retry)="reloadSubjects()"></app-error-state>
      } @else if (primSubjects.length === 0) {
        <app-empty-state class="prim-grid__subjects"
                         icon="book"
                         titleKey="DASHBOARD.EMPTY_TITLE"
                         messageKey="DASHBOARD.EMPTY_DESC"></app-empty-state>
      } @else {
        <app-subjects-card class="prim-grid__subjects"
          [subjects]="primSubjects"
          titleKey="DASHBOARD.PRIMARY.SUBJECTS_TITLE"
          iconBg="var(--cgreen5)"
          iconColor="#fff"
          iconClass="fa-solid fa-book"
          [columns]="3"
          viewAllLink="/student/tests"></app-subjects-card>
      }

      <app-prim-badges-card class="prim-grid__badges"
        [badges]="primBadges"></app-prim-badges-card>

      @if (recentHistory.length > 0) {
        <app-recent-activity-card class="prim-grid__recent"
          [results]="recentHistory"
          titleKey="DASHBOARD.PRIMARY.RECENT_TITLE"></app-recent-activity-card>
      }

      <app-leaderboard-card class="prim-grid__leaderboard"
        [entries]="leaderboardEntries"
        [loading]="leaderboardLoading"></app-leaderboard-card>
    </div>
  </div>

} @else {

  <!-- ═══════════════════════════════════════════════════════════════
       DASHBOARD · COLLÈGE / LYCÉE
       ═══════════════════════════════════════════════════════════════ -->

  <!-- Erreur de chargement de la progression : jamais de données de substitution -->
  @if (progressionErrored()) {
    <app-error-state titleKey="DASHBOARD.ERROR_TITLE"
                     messageKey="DASHBOARD.ERROR_DESC"
                     (retry)="reloadProgression()"></app-error-state>
  }

  <div class="row">
    <!-- Profile Card -->
    <div class="col-12 col-sm-12 col-md-12 col-lg-5 mb-4 order-1 order-lg-2">
      <app-profile-card [avatar]="currentUserAvatar" [name]="currentUserName"
        kind="student" [learningPath]="learningPathName()" [xp]="xpSummary"
        [points]="progressionScore" [pointsSuffix]="'%'" [statistics]="testStats"
        [showButton]="showsDiagnostic()" [buttonText]="'TEST_SUBJECTS.DIAGNOSTIC' | translate"
        [buttonLink]="'/student/tests/diagnostic'"
        [customClasses]="'text-center bg-dashboard-card border-0 py-1 px-1 br-9 h-100'">
        <div chart>
          <app-pie-legend [progressionData]="progression"></app-pie-legend>
        </div>
      </app-profile-card>
    </div>

    <!-- Right Column : today classes + subjects (replaces training-status) -->
    <div class="col-12 col-sm-12 col-md-12 col-lg-7 order-2 order-lg-1">
      @if (showsSessions()) {
        <div class="mb-4">
          <!-- La quinzaine entière : les onglets « en cours » et « à venir »
               en dépendent, le seul jour les priverait de contenu. -->
          <app-today-classes
            [sessions]="sessions()"
            [loading]="sessionsLoading()"
            [errored]="sessionsErrored()"
            calendarLink="/student/agenda"></app-today-classes>
        </div>
      }
      <div class="mb-4">
        <!-- Leaderboard : Top 5 -->
        <app-leaderboard-card
          [entries]="leaderboardEntries"
          [loading]="leaderboardLoading"></app-leaderboard-card>
      </div>
      <div class="mb-4">
        @if (subjectsErrored()) {
          <app-error-state titleKey="DASHBOARD.ERROR_TITLE"
                           messageKey="DASHBOARD.ERROR_DESC"
                           (retry)="reloadSubjects()"></app-error-state>
        } @else if (dashboardSubjects.length === 0) {
          <app-empty-state icon="book"
                           titleKey="DASHBOARD.EMPTY_TITLE"
                           messageKey="DASHBOARD.EMPTY_DESC"></app-empty-state>
        } @else {
          <app-subjects-card
            [subjects]="dashboardSubjects"
            titleKey="DASHBOARD.PRIMARY.SUBJECTS_TITLE"
            iconBg="linear-gradient(135deg, var(--cpurple1), var(--cpurple0))"
            iconColor="#fff"
            iconClass="fa-solid fa-book-open"
            [columns]="3"
            viewAllLink="/student/tests"></app-subjects-card>
        }
      </div>
    </div>
  </div>

  <!-- Breakdown : Exam + Evaluation -->
  <div class="row">
    <div class="col-12 col-lg-6 mb-4">
      <app-stats-breakdown-card
        titleKey="DASHBOARD.EXAM"
        titleIcon="fa-solid fa-graduation-cap"
        titleIconColor="#696cff"
        [stats]="progression?.examenStats"
        [includeExtremes]="true"></app-stats-breakdown-card>
    </div>

    <div class="col-12 col-lg-6 mb-4">
      <app-stats-breakdown-card
        titleKey="DASHBOARD.EVALUATION"
        titleIcon="fa-solid fa-clipboard-check"
        titleIconColor="#faaf00"
        [stats]="progression?.evaluationStats"></app-stats-breakdown-card>
    </div>
  </div>

  <!-- Recent Activity (with Trend KPI integrated) -->
  @if (recentHistory.length > 0 || progression?.trendPercentage != null) {
    <div class="row">
      <div class="col-12 mb-4">
        <app-recent-activity-card
          [results]="recentHistory"
          [trendPercentage]="progression?.trendPercentage"></app-recent-activity-card>
      </div>
    </div>
  }

}

</div>
